<template>
    <div class="field has-addons">
        <p class="control">
            <button :class="['button is-light', size]" @click="decreaseQty()">-</button>
        </p>
        <p class="control">
            <input readonly :class="['input is-centered', size]"
            v-model="quantity">
        </p>
        <p class="control">
            <button :class="['button is-light', size]" @click="increaseQty()">+</button>
        </p>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        variationId: {
            type: Number
        },
        preSelectedQuantity: {
            type: Number,
            default: null
        },
        size: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            quantity: 100
        }
    },
    computed: {},
    mounted () {
        this.setQuantity()
        if (this.preSelectedQuantity) {
            this.quantity = this.preSelectedQuantity
        }
    },
    methods: {
        increaseQty () {
            this.quantity += 100
        },
        decreaseQty () {
            if (this.quantity > 100) {
                this.quantity -= 100
            }
        },
        setQuantity () {
             this.$emit('setQuantity', { variationId: this.variationId, quantity: this.quantity })
        }
    },
    watch: {
        quantity () {
           this.setQuantity()
        }
    }
}
</script>

<style lang="sass" scoped>

</style>